/** 录音状态 */
export type RecordingState = 'idle' | 'recording' | 'processing';

/** 语音转写响应 */
export interface TranscribeResponse {
  id: string;
  /** LLM 优化后的文本（推荐使用） */
  text: string;
  /** Whisper 原始转写 */
  rawText: string;
  /** 音频时长（秒） */
  duration: number;
  /** 转写分段（可选） */
  segments?: TranscribeSegment[];
}

/** 转写分段 */
export interface TranscribeSegment {
  start: number;
  end: number;
  text: string;
}

/** 语音错误码 */
export enum SpeechErrorCode {
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  /** 用户忽略/关闭了权限弹窗，需要去设置中手动授权 */
  PERMISSION_DISMISSED = 'PERMISSION_DISMISSED',
  NETWORK_ERROR = 'NETWORK_ERROR',
  TRANSCRIPTION_ERROR = 'TRANSCRIPTION_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
}

/** 支持的音频 MIME 类型优先级列表 */
export const SUPPORTED_MIME_TYPES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/ogg;codecs=opus',
] as const;

/** 最大录音时长（秒） */
export const MAX_RECORDING_DURATION = 300;

/** 转写请求超时时间（毫秒） */
export const TRANSCRIBE_TIMEOUT = 200000;

/** 权限请求超时时间（毫秒） */
export const PERMISSION_TIMEOUT = 10000;
